(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["big-pack-cart-terms"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('big-pack-cart-terms')) {
  customElements.define('big-pack-cart-terms', class extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.time = this.querySelector('[data-ack-time]');
      if (!this.checkbox) return;
      this.reset = () => {
        this.checkbox.checked = false;
        this.time.value = '';
        this.time.disabled = true;
      };
      this.onChange = () => {
        this.time.disabled = !this.checkbox.checked;
        this.time.value = this.checkbox.checked ? new Date().toISOString() : '';
      };
      this.onCartChange = (event) => {
        if (event.target.matches('[name="updates[]"]') || event.target.closest('cart-remove-button')) this.reset();
      };
      this.onSubmit = (event) => {
        if (event.target.id !== 'cart' || event.submitter?.classList.contains('cart__update-button')) return;
        if (!this.checkbox.checked) {
          event.preventDefault();
          this.checkbox.reportValidity();
        } else {
          this.time.disabled = false;
          this.time.value = new Date().toISOString();
        }
      };
      this.reset();
      this.checkbox.addEventListener('change', this.onChange);
      document.addEventListener('change', this.onCartChange);
      document.addEventListener('click', this.onCartChange);
      document.addEventListener('submit', this.onSubmit, true);
      window.addEventListener('pageshow', this.reset);
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onCartChange);
      document.removeEventListener('click', this.onCartChange);
      document.removeEventListener('submit', this.onSubmit, true);
      window.removeEventListener('pageshow', this.reset);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["big-pack-gallery-controls"] && !Shopify.designMode) return;
  try {
    (()=>{function init(root){root.querySelectorAll('.bp-compact-product').forEach(section=>{if(section.dataset.galleryReady)return;section.dataset.galleryReady='true';const list=section.querySelector('.product__media-list'),buttons=[...section.querySelectorAll('[data-bp-media]')];if(!list||!buttons.length)return;buttons.forEach(button=>button.addEventListener('click',()=>{const item=[...list.children].find(item=>item.dataset.mediaId===button.dataset.bpMedia);if(!item)return;list.scrollTo({left:item.offsetLeft-list.firstElementChild.offsetLeft,behavior:'instant'});buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));list.addEventListener('scroll',()=>{const active=[...list.children].filter(item=>item.offsetWidth).reduce((best,item)=>Math.abs(item.offsetLeft-list.firstElementChild.offsetLeft-list.scrollLeft)<Math.abs(best.offsetLeft-list.firstElementChild.offsetLeft-list.scrollLeft)?item:best,list.firstElementChild);buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.bpMedia===active.dataset.mediaId)));},{passive:true});});}init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["big-pack-preview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('big-pack-preview'))customElements.define('big-pack-preview',class extends HTMLElement{
    connectedCallback(){
      const tick=()=>{const left=Number(this.dataset.release)-Date.now();const el=this.querySelector('[data-countdown]');if(!el)return;const seconds=Math.max(0,Math.floor(left/1000));el.textContent=left>0?`${Math.floor(seconds/86400)}d ${Math.floor(seconds%86400/3600)}h ${Math.floor(seconds%3600/60)}m ${seconds%60}s`:this.dataset.waiting;};
      tick();this.timer=setInterval(tick,1000);
      const time=this.querySelector('time');if(time)time.textContent=new Date(Number(this.dataset.release)).toLocaleString(undefined,{dateStyle:this.classList.contains('bp-preview--compact')?'short':'medium',timeStyle:'short'});
      this.querySelector('[data-remind]')?.addEventListener('click',()=>{
        const escape=s=>String(s).replace(/\\/g,'\\\\').replace(/\n/g,'\\n').replace(/,/g,'\\,').replace(/;/g,'\\;');
        const date=d=>d.toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'');const start=new Date(Number(this.dataset.release)),end=new Date(start.getTime()+900000);
        const lines=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Big Pack//Online release//EN','BEGIN:VEVENT','UID:'+crypto.randomUUID()+'@shopbigpack.com','DTSTAMP:'+date(new Date()),'DTSTART:'+date(start),'DTEND:'+date(end),'SUMMARY:'+escape('Big Pack: '+this.dataset.title),'DESCRIPTION:'+escape('Online release if still available. This reminder does not reserve stock.\n'+this.dataset.url),'URL:'+this.dataset.url,'BEGIN:VALARM','ACTION:DISPLAY','DESCRIPTION:Big Pack online release','TRIGGER:PT0M','END:VALARM','END:VEVENT','END:VCALENDAR'];
        const url=URL.createObjectURL(new Blob([lines.join('\r\n')+'\r\n'],{type:'text/calendar;charset=utf-8'}));const a=document.createElement('a');a.href=url;a.download='big-pack-release.ics';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
      });
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["big-pack-store-proof"] && !Shopify.designMode) return;
  try {
    (()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const cards=[...root.querySelectorAll('[data-review-item]')],grid=root.querySelector('.bp-review-grid'),mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');let offset=0,visible=false;function draw(){const n=2;cards.forEach((card,i)=>card.hidden=!Array.from({length:n},(_,j)=>(offset+j)%cards.length).includes(i));root.querySelector('[data-review-position]').textContent=(offset+1)+' / '+cards.length}function move(delta){offset=(offset+delta+cards.length)%cards.length;draw()}grid.dataset.ready='true';root.querySelector('.bp-review-controls').hidden=false;root.querySelector('[data-review-prev]').addEventListener('click',()=>move(-2));root.querySelector('[data-review-next]').addEventListener('click',()=>move(2));mobile.addEventListener('change',draw);draw();const observer=new IntersectionObserver(e=>visible=e[0].isIntersecting,{threshold:.2});observer.observe(root);const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);observer.disconnect();return}if(visible&&!document.hidden&&!reduced.matches&&!grid.contains(document.activeElement))move(2)},5000)}document.querySelectorAll('[data-review-rotation]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-review-rotation]').forEach(init))})();
  } catch(e) { console.error(e); }
})();

})();
